import api from './api';

const cuttingPlanService = {
  getPlans: async (params = {}) => {
    try {
      const response = await api.get('/cutting-plans', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar planos de corte:', error);
      throw error;
    }
  },

  getPlanById: async (id) => {
    try {
      const response = await api.get(`/cutting-plans/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar plano de corte:', error);
      throw error;
    }
  },

  createPlan: async (data) => {
    try {
      const response = await api.post('/cutting-plans', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar plano de corte:', error);
      throw error;
    }
  },

  updatePlan: async (id, data) => {
    try {
      const response = await api.put(`/cutting-plans/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar plano de corte:', error);
      throw error;
    }
  },

  updatePlanStatus: async (id, status) => {
    try {
      const response = await api.put(`/cutting-plans/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status do plano:', error);
      throw error;
    }
  },

  deletePlan: async (id) => {
    try {
      const response = await api.delete(`/cutting-plans/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar plano de corte:', error);
      throw error;
    }
  },

  getPlanStats: async (params = {}) => {
    try {
      const response = await api.get('/cutting-plans/stats', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      throw error;
    }
  },

  getBoardsByPlan: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-boards/plan/${cutPlanId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar chapas:', error);
      throw error;
    }
  },

  getBoardById: async (id) => {
    try {
      const response = await api.get(`/cutting-boards/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar chapa:', error);
      throw error;
    }
  },

  createBoard: async (data) => {
    try {
      const response = await api.post('/cutting-boards', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar chapa:', error);
      throw error;
    }
  },

  updateBoard: async (id, data) => {
    try {
      const response = await api.put(`/cutting-boards/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar chapa:', error);
      throw error;
    }
  },

  deleteBoard: async (id) => {
    try {
      const response = await api.delete(`/cutting-boards/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar chapa:', error);
      throw error;
    }
  },

  getPositionsByPlan: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-positions/plan/${cutPlanId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posições:', error);
      throw error;
    }
  },

  getPositionsByBoard: async (boardId) => {
    try {
      const response = await api.get(`/cutting-positions/board/${boardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posições:', error);
      throw error;
    }
  },

  getPositionById: async (id) => {
    try {
      const response = await api.get(`/cutting-positions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar posição:', error);
      throw error;
    }
  },

  createPosition: async (data) => {
    try {
      const response = await api.post('/cutting-positions', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar posição:', error);
      throw error;
    }
  },

  updatePosition: async (id, data) => {
    try {
      const response = await api.put(`/cutting-positions/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar posição:', error);
      throw error;
    }
  },

  deletePosition: async (id) => {
    try {
      const response = await api.delete(`/cutting-positions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar posição:', error);
      throw error;
    }
  },

  getLabelsByPlan: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-labels/plan/${cutPlanId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar etiquetas:', error);
      throw error;
    }
  },

  getLabelById: async (id) => {
    try {
      const response = await api.get(`/cutting-labels/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar etiqueta:', error);
      throw error;
    }
  },

  markLabelPrinted: async (id) => {
    try {
      const response = await api.put(`/cutting-labels/${id}/print`);
      return response.data;
    } catch (error) {
      console.error('Erro ao marcar etiqueta como impressa:', error);
      throw error;
    }
  },

  invalidateLabel: async (id, reason) => {
    try {
      const response = await api.put(`/cutting-labels/${id}/invalidate`, { reason });
      return response.data;
    } catch (error) {
      console.error('Erro ao invalidar etiqueta:', error);
      throw error;
    }
  },

  getLabelStats: async (cutPlanId) => {
    try {
      const response = await api.get(`/cutting-labels/plan/${cutPlanId}/stats`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas de etiquetas:', error);
      throw error;
    }
  },

  getModulesByProject: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/modules`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar módulos:', error);
      throw error;
    }
  },

  getPartsByModule: async (moduleId) => {
    try {
      const response = await api.get(`/furniture-modules/${moduleId}/parts`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar peças:', error);
      throw error;
    }
  },

  calculatePlan: async (planId, moduleId = null) => {
    try {
      const response = await api.post(`/cutting-plans/${planId}/calculate`, { moduleId });
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular plano:', error);
      throw error;
    }
  },

  generatePlan: async (planId, data) => {
    try {
      const response = await api.post(`/cutting-plans/${planId}/generate`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar plano:', error);
      throw error;
    }
  }
};

export default cuttingPlanService;
